import writeXlsxFile from "write-excel-file";
import { toast } from "react-toastify";
// service
import { getAllUploadApp } from "../../../utils/services/uploadapp";

// formata a data de criação do upload para "DD-MM-AAAA - HH:mm"
function formatDate(date) {
  if (!date) return "";

  const dateFormat = date.split("T")[0].split("-").reverse().join("-");
  const time = date.split("T")[1]?.slice(0, 5) ?? "";
  return `${dateFormat} - ${time}`;
}

// atualiza a barra de progresso do WaitExport
function updateProgress(current, total) {
  const progressBar = document.querySelector(".export-progress");
  const percentageBar = document.querySelector(".export-percentage");
  const percentage = (current / total) * 100;

  if (progressBar) progressBar.style.width = `${percentage}%`;
  if (percentageBar) percentageBar.innerHTML = `${percentage.toFixed(0)}%`;
}

// busca todas as páginas de uploads do evento e gera o arquivo xlsx
export async function createXlsx({
  eventId,
  limit,
  search,
  totalItems,
  setFinishExport,
  setExportInProgress,
}) {
  const schema = [
    {
      column: "ID do Evento",
      type: String,
      value: (e) => e.event,
    },
    {
      column: "Nome do Evento",
      type: String,
      value: (e) => e.eventName,
    },
    {
      column: "ID do Participante",
      type: String,
      value: (e) => e.loginId,
    },
    {
      column: "Nome do Participante",
      type: String,
      value: (e) => e.loginName,
    },
    {
      column: "URL",
      type: String,
      value: (e) => e.url,
    },
    {
      column: "Data e Hora",
      type: String,
      value: (e) => formatDate(e.createdAt),
    },
  ];

  try {
    const allData = [];
    const numberOfRequisitions = Math.ceil(totalItems / limit);

    for (let page = 1; page <= numberOfRequisitions; page += 1) {
      const res = await getAllUploadApp(page, limit, eventId, search);

      if (!res?.data?.findAllUpload) {
        throw new Error("Erro ao buscar uploads.");
      }

      allData.push(...res.data.findAllUpload.data);
      updateProgress(page, numberOfRequisitions);
    }

    if (allData.length > 0) {
      await writeXlsxFile(allData, {
        schema,
        fileName: "uploads-app.xlsx",
      });
    }

    setTimeout(() => {
      setFinishExport(true);
    }, 1000);
  } catch (error) {
    setExportInProgress(false);
    toast.error("Erro ao exportar relatório de uploads.");
  }
}
